import { fluidSizing } from 'src/utils';
import styled, { css } from 'styled-components';
import { OxImage } from 'src/components/OxImage';
import { OxTextParagraph } from 'src/components/OxTextParagraph';

export const Container = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        ${theme.breakpoints.up('m')} {
            flex-direction: row-reverse;
        }
    `
);

export const Asset = styled.div<{ assetHeight?: (number | null)[] }>(
    ({ theme, assetHeight }) => css`
        position: relative;
        width: 100%;
        ${fluidSizing([{ prop: 'margin-bottom', values: [10, null, null] }])}
        ${theme.breakpoints.up('m')} {
            width: 50%;
            height: auto;
            margin-bottom: 0;
        }
        ${fluidSizing([{ prop: 'height', values: assetHeight ?? [300, 250, 450] }])}
    `
);

export const AssetImage = styled(OxImage)<{ assetHeight?: (number | null)[] }>(
    ({ assetHeight }) => css`
        width: 100%;
        height: 100%;
        ${fluidSizing([{ prop: 'height', values: assetHeight ?? [300, 250, 450] }])}
    `
);

export const ContentWrapper = styled.div<{
    isFirst?: boolean;
    contentHeight?: (number | null)[];
}>(
    ({ theme, isFirst, contentHeight }) => css`
        width: 100%;

        ${fluidSizing([
            { prop: 'height', values: contentHeight ?? [null, 250, 450] },
            { prop: 'padding-left', values: isFirst ? [] : [0, 20, 30] },
            { prop: 'padding-right', values: [0, 20, 30] }
        ])}

        ${theme.breakpoints.up('s')} {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        ${theme.breakpoints.up('m')} {
            width: 50%;
        }
    `
);

export const Headers = styled.div(
    ({ theme }) => css`
        ${theme.breakpoints.only('xs')} {
            display: none;
        }
    `
);

export const ToggleButton = styled.button<{ isActive: boolean }>(
    ({ theme, isActive }) => css`
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 2;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${isActive ? theme.colors.primary.main : 'rgba(0, 0, 0, 0.7)'};
        color: ${theme.colors.basic.white};
        border: 2px solid ${isActive ? theme.colors.primary.main : 'rgba(255, 255, 255, 0.3)'};
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            background: ${isActive ? theme.colors.primary.variant : 'rgba(0, 0, 0, 0.8)'};
            border-color: ${isActive ? theme.colors.primary.variant : 'rgba(255, 255, 255, 0.5)'};
            transform: scale(1.05);
        }

        ${theme.breakpoints.up('s')} {
            width: 48px;
            height: 48px;
        }
    `
);
